import { render, staticRenderFns } from "./bookstore.vue?vue&type=template&id=1d8ace18&scoped=true&"
import script from "./bookstore.vue?vue&type=script&lang=js&"
export * from "./bookstore.vue?vue&type=script&lang=js&"
import style0 from "./bookstore.vue?vue&type=style&index=0&id=1d8ace18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ace18",
  null
  
)

export default component.exports